import mitt from 'mitt';
//   oauthEmitter.emit('AccessTokenChanged', null);
//   if (!silent) {
//     oauthEmitter.emit('AfterLogout');
const emitter = mitt();
export default function useOAuthEmitter() {
    return emitter;
}
